import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    TranscribeActivityCall as TranscribeActivityCallMutation,
    TranscribeActivityCallVariables,
    ActivityTranscribeCallInput,
} from 'nutshell-graphql-types';

import TRANSCRIBE_ACTIVITY_CALL from '../mutations/transcribe-activity-call.graphql';

export const useTranscribeActivityCall = (
    activityId: string
): {
    transcribeActivityCall: (arg1: ActivityTranscribeCallInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [transcribeActivityCall, {loading, error}] = useMutation<
        TranscribeActivityCallMutation,
        TranscribeActivityCallVariables
    >(TRANSCRIBE_ACTIVITY_CALL, {variables: {input: {activityId}}});

    return {
        transcribeActivityCall: (input: ActivityTranscribeCallInput) =>
            transcribeActivityCall({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
